/**
 * Theme Interactive Elements
 * Handles UI interactions and content positioning
 * Load with: <script src="theme-interactions.js" async defer></script>
 */

(function () {
  "use strict";

  // Early exit if already loaded
  if (window.themeInteractionsLoaded) return;
  window.themeInteractionsLoaded = true;

  /**
   * Initialize all theme interactions when DOM is ready
   */
  function initializeThemeInteractions() {
    try {
      // Initialize collagen content toggle
      initializeCollagenToggle();

      // Initialize enzyme content toggle
      initializeEnzymeToggle();

      // Initialize content positioning
      initializeContentPositioning();

      console.log("✅ Theme interactions initialized");
    } catch (error) {
      console.warn("Theme interactions initialization failed:", error);
    }
  }

  /**
   * Initialize collagen content toggle
   */
  function initializeCollagenToggle() {
    var toggleButton = document.getElementById("toggle-collagen-content");
    var collagenContent = document.getElementById("collagen-content");

    if (toggleButton && collagenContent) {
      toggleButton.addEventListener("click", function () {
        if (collagenContent.style.display === "none") {
          collagenContent.style.display = "block";
        } else {
          collagenContent.style.display = "none";
        }
      });
    }
  }

  /**
   * Initialize enzyme content toggle
   */
  function initializeEnzymeToggle() {
    var toggleButton = document.getElementById("toggle-enzyme-content");
    var enzymeContent = document.getElementById("enzyme-content");

    if (toggleButton && enzymeContent) {
      toggleButton.addEventListener("click", function () {
        if (enzymeContent.style.display === "none") {
          enzymeContent.style.display = "block";
        } else {
          enzymeContent.style.display = "none";
        }
      });
    }
  }

  /**
   * Initialize content positioning for certificate carousel
   */
  function initializeContentPositioning() {
    // Move collagen content
    var contentToMove = document.getElementById("content-to-move");
    var targetLocation = document.querySelector(
      "#shopify-section-template--16761575473437__867f184d-de23-4190-99f8-fb15ce676958 > section.c-certificate-carousel.is-desktop"
    );

    if (contentToMove && targetLocation) {
      targetLocation.parentNode.insertBefore(contentToMove, targetLocation);
    }

    // Move enzyme content
    var contentToMoveEnzyme = document.getElementById("content-to-move-enzyme");
    var targetLocationEnzyme = document.querySelector(
      "#shopify-section-template--16761575473437__867f184d-de23-4190-99f8-fb15ce676958 > section.c-certificate-carousel.is-desktop"
    );

    if (contentToMoveEnzyme && targetLocationEnzyme) {
      targetLocationEnzyme.parentNode.insertBefore(
        contentToMoveEnzyme,
        targetLocationEnzyme
      );
    }
  }

  // Initialize when DOM is ready or immediately if already ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeThemeInteractions);
  } else {
    initializeThemeInteractions();
  }
})();
